import React from 'react';

import Section from 'components/Section';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { htmlT } from 'utils/generic';

import GroupCabinItem from './GroupCabinItem';
import { CabinTitle } from './styles';

interface Props {
  domesticCabinTypes: string[];
  internationalCabinTypes: string[];
  onToggle: (cabinValue: string, type: 'domestic' | 'international') => void;
}

const GroupCabins = ({ onToggle, domesticCabinTypes, internationalCabinTypes }: Props) => {
  const { t } = useStoreTranslation();

  const domesticCabins = [
    { text: t('flightsSearch.cabin.economy'), value: 'economy', type: 'domestic' },
    { text: t('flightsSearch.cabin.premiumEconomy'), value: 'economyPremium', type: 'domestic' },
    { text: t('flightsSearch.cabin.business'), value: 'business', type: 'domestic' },
    { text: t('flightsSearch.cabin.first'), value: 'firstClass', type: 'domestic' },
  ];

  const internationalCabins = [
    { text: t('flightsSearch.cabin.economy'), value: 'economy', type: 'international' },
    { text: t('flightsSearch.cabin.premiumEconomy'), value: 'economyPremium', type: 'international' },
    { text: t('flightsSearch.cabin.business'), value: 'business', type: 'international' },
    { text: t('flightsSearch.cabin.first'), value: 'firstClass', type: 'international' },
  ];

  const renderDomesticCabins = () =>
    domesticCabins.map((c, index) => (
      <React.Fragment key={index}>
        <GroupCabinItem
          cabinName={c.text}
          cabinValue={c.value}
          isActive={domesticCabinTypes?.find((t) => t === c.value) !== undefined ? true : false}
          onToggle={onToggle}
          key={c.text}
          type="domestic"
        />
      </React.Fragment>
    ));

  const renderInternationalCabins = () =>
    internationalCabins.map((c, index) => (
      <React.Fragment key={index}>
        <GroupCabinItem
          cabinName={c.text}
          cabinValue={c.value}
          isActive={internationalCabinTypes?.find((t) => t === c.value) !== undefined ? true : false}
          onToggle={onToggle}
          key={c.text}
          type="international"
        />
      </React.Fragment>
    ));

  return (
    <Section title={t('group.cabins.title')} details={htmlT(t, 'group.cabins.details')}>
      <div>
        <CabinTitle>Nacional</CabinTitle>
        {renderDomesticCabins()}
      </div>
      <div>
        <CabinTitle>Internacional</CabinTitle>
        <div>{renderInternationalCabins()}</div>
      </div>
    </Section>
  );
};

export default GroupCabins;
